<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13.019"
    height="13.293"
    viewBox="0 0 13.019 13.293"
  >
    <path
      d="M6.646 4 10.368.273l2.651 2.651L9.3 6.646l3.723 3.723-2.651 2.651L6.646 9.3l-3.994 4L0 10.642l3.994-4L0 2.652 2.651 0Z"
      data-name="Path 1"
    />
  </svg>
</template>
